import type { KeepStateOptions } from "react-hook-form";

// Without `keepFieldsRef`, reset drops every registered field. A Controller whose
// value didn't change is memoized by React Compiler and never re-registers, so
// typing into it would silently do nothing.
export const RESET_OPTIONS: KeepStateOptions = { keepFieldsRef: true };
